import React from 'react';

const IconMOutline = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="feather feather-m-outline">
    <title>Outline M</title>
    <path d="M1 20V5h5l5 8 4-8h7v16h-6V10l-6 9-9-9v11H4z"></path>
    {/* <path d="M1 20V5h5l5 8 5-8h7v16h-8V12l-2 9-8-9v8H2z"></path> */}

    {/* <path d="M1 20V5h5l5 8 4-8h7v16h-6V10l-6 9-8-9v8H4z"></path> */}
  </svg>
);

export default IconMOutline;
